import Home from './pages/Home.js';
import Gaydar from './pages/Gaydar';
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { Suspense, lazy } from 'react';
import './App.css';

// three.js is ~165KB gzipped, so the Baja viewer is split out and only
// fetched when someone actually opens /baja
const Baja = lazy(() => import('./pages/Baja'));
const Darkroom = lazy(() => import('./pages/Darkroom'));

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gaydar" element={<Gaydar />} />
          <Route path="/darkroom" element={<Suspense fallback={null}><Darkroom /></Suspense>} />
          <Route path="/baja" element={<Suspense fallback={null}><Baja /></Suspense>} />

          {/* The old separate pages are now sections of the one page. */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/portfolio" element={<Navigate to="/#work" replace />} />
          <Route path="/about" element={<Navigate to="/#experience" replace />} />
          <Route path="/contact" element={<Navigate to="/" replace />} />

          <Route path="*" element={
            <div className="error-page">
              <h1 className="t-display">404</h1>
              <p className="t-body">That page isn&rsquo;t in the archive.</p>
              <Link to="/" className="error-page__back">← Back to the start</Link>
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
